module.exports = __webpack_public_path__ + "static/media/OurWorkCategory_Mobile.c80ea57f.svg";